<div [className]="className" [style]="styleName">

     <fieldset>
            <legend [className]="labelClass" 
                    [style]="labelStyle" 
                    [translateParams]="labelParam" translate>
                    <span [innerHTML]="label|translate:labelParam"></span>
                    <ng-content></ng-content> 
            </legend>

            <div *ngIf="hintText" [className]="hintClass"  [innerHTML]="hintText|translate:hintParam"
                                    [style]="hintlStyle"></div>


            <div class="ontario-radios h-direction">
                  <!--
                  <div class="ontario-radios__item"
                      *ngFor="let item of dataList | keyvalue : asIsOrder ;let i = index ">

                        <input  value="{{item.key}}" contenteditable
                                [attr.disabled]="disable?true:null"
                                name="{{name}}" 
                                id="{{name}}_{{i}}"   
                                [className]="inputClass"  [style]="inputStyle" 
                               [ngModel]="input.toString()"
                               (ngModelChange)="inputModelChange($event)"
                               (change)="valueChanged()"
                                
                                type="radio">

                        <label for="{{name}}_{{i}}"
                              [className]="textClass"                    
                              [style]="textStyle" 
                              [ngClass]="{'input-disabled':disable}"
                              [innerHTML]="item.value">
                        </label>
                  </div>
                  -->
            </div>
     </fieldset>


     <div [hidden]="!error"
          [className]="errorClass" 
           style="margin-left:0.30em"
          [style]="errorStyle" id="error_{{name}}">
                  <b>{{!error? '':'error.prefix'| translate}}</b>
                  <span class="" [innerHTML]="error|translate:errorParam" ></span>
     </div>
</div>


